(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-care-body"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-ff-care-section]'));
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-ff-toc-link]'));
    if (sections.length === 0 || links.length === 0) return;

    function highlight(id) {
      links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-ff-toc-link') === id); });
    }

    highlight(sections[0].getAttribute('data-ff-care-section'));
    if (!('IntersectionObserver' in window)) return;

    /* Active = the topmost section whose box is inside the 20%–40%-from-top band. */
    var visible = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        visible[e.target.getAttribute('data-ff-care-section')] = e.isIntersecting;
      });
      for (var i = 0; i < sections.length; i++) {
        var id = sections[i].getAttribute('data-ff-care-section');
        if (visible[id]) { highlight(id); return; }
      }
    }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 });
    sections.forEach(function (s) { observer.observe(s); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-collection-email-capture"] && !Shopify.designMode) return;
  try {
    
  /* fix9 — flip the button to the design's confirmed state ("Joined") the
     moment the native customer-form POST is submitted. The server-side
     posted_successfully? state still renders after the round-trip. */
  document.querySelectorAll('.ff-cemail__form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var button = form.querySelector('button[type="submit"]');
      if (button) button.textContent = 'Joined';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-collection-filter-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-ff-cfilter]');
    if (!bar) return;
    var form = bar.querySelector('[data-ff-cfilter-form]');

    bar.querySelectorAll('[data-ff-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var panel = btn.nextElementSibling;
        var open = panel.classList.contains('is-open');
        bar.querySelectorAll('[data-ff-filter-panel]').forEach(function (p) { p.classList.remove('is-open'); });
        bar.querySelectorAll('[data-ff-filter-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
        if (!open) {
          panel.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-ff-filter-anchor]')) {
        bar.querySelectorAll('[data-ff-filter-panel]').forEach(function (p) { p.classList.remove('is-open'); });
        bar.querySelectorAll('[data-ff-filter-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
    });

    form.addEventListener('change', function () { form.submit(); });

    /* ── Mobile bottom sheets (fix7; keyboard/focus behaviour fixE) ── */
    var overlay = bar.querySelector('[data-ff-sheet-overlay]');
    if (!overlay) return;
    var sheetTrigger = null;

    function openSheet(name, trigger) {
      var sheet = bar.querySelector('[data-ff-sheet="' + name + '"]');
      if (!sheet) return;
      sheetTrigger = trigger || null;
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      overlay.hidden = false;
      sheet.hidden = false;
      // double rAF so the un-hidden state paints before the transition starts
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlay.classList.add('is-open');
          sheet.classList.add('is-open');
          var closeButton = sheet.querySelector('[data-ff-sheet-close]');
          if (closeButton) closeButton.focus();
        });
      });
    }

    function closeSheets() {
      var wasOpen = overlay.classList.contains('is-open');
      overlay.classList.remove('is-open');
      bar.querySelectorAll('[data-ff-sheet]').forEach(function (s) { s.classList.remove('is-open'); });
      bar.querySelectorAll('[data-ff-sheet-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (wasOpen && sheetTrigger) {
        sheetTrigger.focus();
        sheetTrigger = null;
      }
      window.setTimeout(function () {
        if (!overlay.classList.contains('is-open')) {
          overlay.hidden = true;
          bar.querySelectorAll('[data-ff-sheet]').forEach(function (s) { s.hidden = true; });
        }
      }, 340);
    }

    bar.querySelectorAll('[data-ff-sheet-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () { openSheet(btn.getAttribute('data-ff-sheet-open'), btn); });
    });
    overlay.addEventListener('click', closeSheets);
    bar.querySelectorAll('[data-ff-sheet-close]').forEach(function (btn) {
      btn.addEventListener('click', closeSheets);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSheets();
    });

    // Sort sheet: applying a sort closes the sheet and submits the form via
    // the form's own (hidden) select, so active filters carry through.
    var sortSelect = form.querySelector('[name="sort_by"]');
    bar.querySelectorAll('input[name="ff-sheet-sort"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (sortSelect) sortSelect.value = radio.value;
        closeSheets();
        form.submit();
      });
    });

    // Filter sheet: Apply syncs the unnamed sheet mirrors into the real form
    // inputs, then submits. Clear only resets the sheet state — nothing
    // navigates until Apply.
    var applyBtn = bar.querySelector('[data-ff-sheet-apply]');
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        bar.querySelectorAll('[data-ff-sheet-param]').forEach(function (mirror) {
          var name = mirror.getAttribute('data-ff-sheet-param');
          var value = mirror.getAttribute('data-ff-sheet-value');
          form.querySelectorAll('input[type="checkbox"][name="' + CSS.escape(name) + '"]').forEach(function (real) {
            if (real.value === value) real.checked = mirror.checked;
          });
        });
        bar.querySelectorAll('[data-ff-sheet-price]').forEach(function (mirror) {
          var real = form.querySelector('input[name="' + CSS.escape(mirror.getAttribute('data-ff-sheet-price')) + '"]');
          if (real) real.value = mirror.value;
        });
        closeSheets();
        form.submit();
      });
    }

    var clearBtn = bar.querySelector('[data-ff-sheet-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        bar.querySelectorAll('[data-ff-sheet-param]').forEach(function (mirror) { mirror.checked = false; });
        bar.querySelectorAll('[data-ff-sheet-price]').forEach(function (mirror) { mirror.value = ''; });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-email-capture"] && !Shopify.designMode) return;
  try {
    
  /* fix9 — flip the button to the design's confirmed state ("Joined") the
     moment the native customer-form POST is submitted. The server-side
     posted_successfully? state still renders after the round-trip. */
  document.querySelectorAll('.ff-email__form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var button = form.querySelector('button[type="submit"]');
      if (button) button.textContent = 'Joined';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-faq-body"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var groups = Array.prototype.slice.call(document.querySelectorAll('[data-ff-faq-group]'));
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-ff-faq-link]'));
    var chips = Array.prototype.slice.call(document.querySelectorAll('[data-ff-faq-chip]'));
    if (groups.length === 0) return;

    function highlight(id) {
      links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('data-ff-faq-link') === id); });
      chips.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-ff-faq-chip') === id); });
    }

    highlight(groups[0].getAttribute('data-ff-faq-group'));
    if (!('IntersectionObserver' in window)) return;

    /* Active = the topmost group whose box is inside the 20%–40%-from-top band. */
    var visible = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        visible[e.target.getAttribute('data-ff-faq-group')] = e.isIntersecting;
      });
      for (var i = 0; i < groups.length; i++) {
        var id = groups[i].getAttribute('data-ff-faq-group');
        if (visible[id]) { highlight(id); return; }
      }
    }, { rootMargin: '-20% 0px -60% 0px', threshold: 0 });
    groups.forEach(function (g) { observer.observe(g); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-footer"]) return;
  try {
    
  /* fix9 — flip the button to the design's confirmed state ("Joined") the
     moment the native customer-form POST is submitted. The server-side
     posted_successfully? state still renders after the round-trip. */
  document.querySelectorAll('.ff-footer__form').forEach(function (form) {
    form.addEventListener('submit', function () {
      var button = form.querySelector('button[type="submit"]');
      if (button) button.textContent = 'Joined';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-pdp-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var track = root.querySelector('[data-ff-gallery-track]');
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ff-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ff-thumb]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ff-dot]'));
      var counter = root.querySelector('[data-ff-counter]');
      var prevBtn = root.querySelector('[data-ff-prev]');
      var nextBtn = root.querySelector('[data-ff-next]');
      if (slides.length < 2) return;
      var current = 0;

      function setActive(idx) {
        current = Math.max(0, Math.min(idx, slides.length - 1));
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
        if (counter) counter.textContent = (current + 1) + ' / ' + slides.length;
        if (prevBtn) prevBtn.disabled = current === 0;
        if (nextBtn) nextBtn.disabled = current === slides.length - 1;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { setActive(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { setActive(current + 1); });

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () { setActive(i); });
      });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', function () {
        if (window.innerWidth >= 769) return;
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });

      setActive(0);
    }

    document.querySelectorAll('[data-ff-gallery]').forEach(init);
  })();

  /* Live ATC total — v2 interactions: button label shows qty × unit price.
     Listens on the quantity input only; never touches Horizon's
     quantity-selector / product-form component internals. The button is not
     an aria-live region, so updates stay silent for screen readers (the
     input's own aria-live="polite" already announces the quantity). */
  (function () {
    document.querySelectorAll('[data-ff-atc-unit-cents]').forEach(function (formEl) {
      var cents = parseInt(formEl.getAttribute('data-ff-atc-unit-cents'), 10);
      var totalEl = formEl.querySelector('[data-ff-atc-total]');
      var input = formEl.querySelector('input[name="quantity"]');
      if (!cents || !totalEl || !input) return;

      /* v2 qty-max: the design clamps the stepper at available stock. Horizon's
         quantity-selector already respects the input's max attribute (it renders
         one when a quantity rule exists); supply it from inventory when the
         variant can't oversell. */
      var stock = parseInt(formEl.getAttribute('data-ff-atc-stock'), 10);
      if (stock > 0 && !input.hasAttribute('max')) input.setAttribute('max', stock);

      function format(c) {
        return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      function update() {
        var qty = parseInt(input.value, 10);
        if (!qty || qty < 1) return;
        totalEl.textContent = format(cents * qty);
      }

      input.addEventListener('input', update);
      input.addEventListener('change', update);
      /* Horizon's /setQuantity clamps out-of-range typed values on blur
         without firing input/change — re-read after it settles. */
      input.addEventListener('blur', function () {
        requestAnimationFrame(update);
        setTimeout(update, 80);
      });
      /* The +/− buttons set the input value programmatically, which doesn't
         always fire input/change — re-read once the click has settled. */
      formEl.addEventListener('click', function (e) {
        if (e.target.closest('button[name="plus"], button[name="minus"]')) {
          requestAnimationFrame(update);
          setTimeout(update, 80);
        }
      });
      update();
    });
  })();

  /* Klaviyo — Viewed Product.

     Klaviyo's Shopify integration hangs product-view tracking off the stock
     product template hook. This theme renders ff-pdp-main instead of Horizon's
     product-information, so that hook never ran: the metric had recorded zero
     events ever, against 563 sessions in 60 days, and flow "3 · Browse
     abandonment" was live but could never trigger. Diagnosed 4 Aug 2026.

     window.klaviyo is a replaying queue before klaviyo.js finishes loading and
     the real object afterwards — both take .push(). So create the queue when
     it's missing rather than bailing out, otherwise we lose exactly the race
     we're trying to survive.

     Both calls are needed: `track` populates the metric that triggers the
     flow, `trackViewedItem` populates the recently-viewed block the email
     renders. */
  (function () {
    function send() {
      var el = document.querySelector('[data-ff-pdp][data-klaviyo-product]');
      if (!el) return;

      var item;
      try {
        item = JSON.parse(el.getAttribute('data-klaviyo-product'));
      } catch (e) {
        return;
      }
      if (!item || !item.ProductID) return;

      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', 'Viewed Product', item]);
      window.klaviyo.push([
        'trackViewedItem',
        {
          Title: item.ProductName,
          ItemId: item.ProductID,
          Categories: item.Categories,
          ImageUrl: item.ImageURL,
          Url: item.URL,
          Metadata: {
            Brand: item.Brand,
            Price: item.Price,
            CompareAtPrice: item.CompareAtPrice
          }
        }
      ]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', send);
    } else {
      send();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-pdp-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-ff-sticky]');
    var anchor = document.querySelector('[data-ff-pdp]');
    if (!bar || !anchor) return;
    function onScroll() {
      var r = anchor.getBoundingClientRect();
      bar.classList.toggle('is-visible', r.bottom < 0);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
